import React from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { useStore } from '../../../store';
import SRFLogo from './SRF_Logo.svg';
function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const { translation } = useStore();

  const path = location.pathname;
  let title;

  switch (true) {
    case path.startsWith('/list/drafts'):
      title = translation.drafts;
      break;
    case path.startsWith('/list/pending'):
      title = translation.pendingSubmissions;
      break;
    case path.startsWith('/list/history'):
      title = translation.submissions;
      break;
    case path.startsWith('/settings'):
      title = translation.settings;
      break;
    case path.startsWith('/form'):
      title = translation.newDailyFieldReport;
      break;
    case path.startsWith('/ticket/') && path.endsWith('/pdf'):
      title = "PDF View"
      break;
    default:
      title = translation.home;
  }
  // Show back button on pages other than the home page
  const showBackButton = path !== '/';

  const handleBackClick = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <header className="shadow-md sticky top-0 z-10 bg-[#20346a]">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Left side: Back Button or Logo */}
          <div className="w-1/4">
            {showBackButton ? (
              <button onClick={handleBackClick} className="flex items-center text-blue-600 hover:text-blue-800 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                <span className="hidden sm:inline ml-1 font-semibold">{translation.back}</span>
              </button>
            ) : (
              <Link to="/">
                <img src={SRFLogo} alt="SRF Logo" className="h-8 w-auto" />
              </Link>
            )}
          </div>

          {/* Center: Page Title */}
          <div className="w-1/2 text-center">
            <h1 className="text-lg font-bold text-white truncate">{title}</h1>
          </div>

          {/* Right side: Placeholder for future icons/menu */}
          <div className="w-1/4">
            {/* This space can be used for a user menu, notifications, etc. */}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
